import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";


function ModalUpdateOccurrence(props) {
  console.log("ModalUpdateOccurrence", props);
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
            props.onHide();
            props.loadOccurrences();
          }, 1000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) showNotification("br")
  }, [controlSnack]);

  async function handleCloseOccurrence(e) {
    e.preventDefault();
    const response = await api.patch(`/occurrence/${props.occurrence.id_admin}/${props.occurrence.id}`, { resolve: true });
    if (response.status === 200) {
      setControlSnack(true);
    }

  }


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Fechar ocorrência
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleCloseOccurrence}>
        <Modal.Body>
          <h4> Fechar ocorrência?</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit" >
              CONFIRMAR
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Cliente deletado com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalUpdateOccurrence;